import { ModuleWithProviders, NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";

import { CustomComponentRegistry, CUSTOM_VIEW_REGISTRY } from "./interfaces";
import { CustomViewComponent } from "./customView.component";
import { CustomViewDirective } from "./customView.directive";
import { CustomViewService } from "./customViewService";

@NgModule({
    imports: [BrowserModule],
    declarations: [CustomViewComponent, CustomViewDirective],
    exports: [CustomViewComponent],
    providers: [CustomViewService,
        {
            provide: CUSTOM_VIEW_REGISTRY,
            multi: true,
            useValue: {},
        },]
})
export class CustomViewModule
{
    static withComponents(components: Readonly<CustomComponentRegistry>): ModuleWithProviders<CustomViewModule>
    {
        /*
         * Checking the registry here instead of in the service that will receive all the registries, so that hopefully
         * the errors will specify where the module is being configured incorrectly.
         */
        if (!components)
        {
            throw new Error(`components cannot be falsy.`);
        }

        const verifiedRegistry = Object.keys(components)
            .reduce((r, selector) =>
            {
                if (!selector)
                {
                    throw new Error(`Component selector cannot be falsy.`);
                }

                if (!components[selector])
                {
                    throw new Error(`Invalid ComponentFactory in registry; selector was ${JSON.stringify(selector)}`);
                }

                r[selector] = components[selector];
                return r;
            }, {});

        return {
            ngModule: CustomViewModule,
            providers: [{
                provide: CUSTOM_VIEW_REGISTRY,
                multi: true,
                useValue: verifiedRegistry,
            },],
        };
    }
}
